module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_UP.44521fb4.png";